import { qdfoodApi } from './constant';
import { IPartner } from '@type/partner';

export const PARTNER_API = {
  urlGetPartner: `/partner/list/web-user`,
};

export default class partnerApi {
  static getPartner() {
    return qdfoodApi().get<IPartner[]>(PARTNER_API.urlGetPartner, {
      params: {
        isDeleted: false,
      },
    });
  }
}
